import React, { useEffect, useState } from 'react';
import styles from './ItemModal.module.css';
import { useAllDevicesQuery } from '../../../../store/api/device.api';

export const ItemModal = ({ isOpen, onClose, onSubmit, item = null, schema }) => {
	const { data: devices = [], isLoading: loadingDevices, refetch: refetchDevices } = useAllDevicesQuery();

	const [title, setTitle] = useState('');
	const [img, setImg] = useState('');
	const [price, setPrice] = useState('');
	const [priceDisc, setPriceDisc] = useState('');
	const [priceDiscSub, setPriceDiscSub] = useState('');
	const [lang, setLang] = useState('');
	const [genre, setGenre] = useState('');
	const [edition, setEdition] = useState('');
	const [subscriptionEndDate, setSubscriptionEndDate] = useState('');
	const [inMainSlider, setInMainSlider] = useState(true);
	const [inLeadersSlider, setInLeadersSlider] = useState(true);
	const [selectedDevices, setSelectedDevices] = useState([]);
	const [subscriptionId, setSubscriptionId] = useState('');

	const [region, setRegion] = useState('');
	const [category, setCategory] = useState('');

	const [platform, setPlatform] = useState('');
	useEffect(() => {
		if (item) {
			setTitle(item.title || '');
			setPrice(item.price || '');
			setPriceDisc(item.price_disc || '');
			setPriceDiscSub(item.price_disc_sub || '');
			setLang(item.lang || '');
			setGenre(item.genres?.map(g => g.title).join(', ') || '');
			setEdition(item.edition || '');
			setSubscriptionEndDate(item.subscriptionEndDate ? item.subscriptionEndDate.split('T')[0] : '');
			setSelectedDevices(item.devices ? item.devices.map((d) => d.id) : []);
			setSubscriptionId(item.subscriptionId || '');
			setInMainSlider(item.inMainSlider !== undefined ? item.inMainSlider : true);
			setInLeadersSlider(item.inLeadersSlider !== undefined ? item.inLeadersSlider : true);
			setImg(item.img || '');

			if(schema === 'steam'){
				setRegion(item?.regions.map(reg => reg.title).join(', ') || '');
			} else if(schema === 'fifa'){
				setRegion(item?.Fifa_Region?.title || '');
			} else{
				setRegion(item?.regions?.title || '');
			}
			if(schema === 'fifa') setPlatform(item?.Fifa_Platform?.title || '');
			if (schema === 'services') setCategory(item.categories[0].title || '');
		} else {
			setTitle('');
			setPrice('');
			setPriceDisc('');
			setPriceDiscSub('');
			setLang('');
			setGenre('');
			setSubscriptionEndDate('');
			setSelectedDevices([]);
			setSubscriptionId('');
			setImg('');
			setInMainSlider(true);
			setInLeadersSlider(true);

			setRegion('');
			setCategory('');
		}
		refetchDevices();
	}, [isOpen, item]);

	if (!isOpen) return null;

	const handleDeviceToggle = (deviceId) => {
		setSelectedDevices((prev) =>
			prev.includes(deviceId)
				? prev.filter((id) => id !== deviceId)
				: [...prev, deviceId]
		);
	};

	const handleSubmit = () => {

		if (!schema && selectedDevices.length === 0) {
			alert('Выберите хотя бы одно устройство.');
			return;
		}

		const formData = new FormData();
		formData.append('title', title);
		formData.append('img', img);
		formData.append('price', parseFloat(price));
		formData.append('price_disc', parseFloat(priceDisc));


		if(!schema){
			formData.append('price_disc_sub', parseFloat(priceDiscSub));
			formData.append('lang', lang);
			formData.append('genre', genre);
			formData.append('inMainSlider', inMainSlider ? 'true' : 'false');
			formData.append('inLeadersSlider', inLeadersSlider ? 'true' : 'false');
			formData.append('edition', edition);

			if (subscriptionEndDate) {
				const formattedDate = new Date(subscriptionEndDate).toISOString().split('T')[0];
				formData.append('disc_end_date', formattedDate);
			}

			selectedDevices.forEach((deviceId) => {
				formData.append('deviceIds', deviceId);
			});

			if (subscriptionId) {
				formData.append('subscriptionId', subscriptionId);
			}
		} else if(schema === 'steam'){
			formData.append('regions', region);
		} else {
			formData.append('region', region);
			formData.append('category', category);
		}

		if (item) {
			formData.append('id', item.id);
			onSubmit(formData, item.id);
		} else {
			onSubmit(formData);
		}
	};

	return (
		<div className={styles.overlay}>
			<div className={styles.modal}>
				<h2>{item ? 'Редактировать товар' : 'Добавить товар'}</h2>
				<form>
					{
						schema ?
							<>
								<input
									name="title"
									placeholder="Название"
									value={title}
									onChange={(e) => setTitle(e.target.value)}
									required
								/>
								{
									schema !== 'fifa' &&
									<input
										name="img"
										value={img}
										placeholder="ссылка на изображение"
										onChange={(e) => setImg(e.target.value)}
									/>
								}
								
								<input
									name="price"
									type="number"
									placeholder="Цена"
									value={price}
									onChange={(e) => setPrice(e.target.value)}
									required
								/>
								<input
									name="price_disc"
									type="number"
									placeholder="Цена со скидкой"
									value={priceDisc}
									onChange={(e) => setPriceDisc(e.target.value)}
								/>
								<input
									name="Регион"
									placeholder="Регион"
									value={region}
									onChange={(e) => setRegion(e.target.value)}
								/>
								{
									schema === 'fifa' &&
									<input
										name="Платформа"
										placeholder="Платформа"
										value={platform}
										onChange={(e) => setPlatform(e.target.value)}
									/>
								}
								{
									schema === 'services' &&
									<input
										name="Категория"
										placeholder="Категория"
										value={category}
										onChange={(e) => setCategory(e.target.value)}
									/>
								}
							</>
							:
							<>
								<input
									name="title"
									placeholder="Название"
									value={title}
									onChange={(e) => setTitle(e.target.value)}
									required
								/>
								<input
									name="img"
									value={img}
									placeholder="ссылка на изображение"
									onChange={(e) => setImg(e.target.value)}
								/>
								<input
									name="price"
									type="number"
									placeholder="Цена"
									value={price}
									onChange={(e) => setPrice(e.target.value)}
									required
								/>
								<input
									name="price_disc"
									type="number"
									placeholder="Цена со скидкой"
									value={priceDisc}
									onChange={(e) => setPriceDisc(e.target.value)}
								/>
								<input
									name="price_disc_sub"
									type="number"
									placeholder="Цена со скидкой по подписке"
									value={priceDiscSub}
									onChange={(e) => setPriceDiscSub(e.target.value)}
								/>
								<input
									name="lang"
									placeholder="Язык"
									value={lang}
									onChange={(e) => setLang(e.target.value)}
								/>
								<input
									name="subscriptionEndDate"
									type="date"
									value={subscriptionEndDate}
									onChange={(e) => setSubscriptionEndDate(e.target.value)}
								/>
								<input
									name="genre"
									placeholder="Жанр"
									value={genre}
									onChange={(e) => setGenre(e.target.value)}
								/>

								<h3 className={styles.titleH3}>На главном слайдере:</h3>
								<div className={styles.checkboxLabel}>
									<p>Показывать</p>
									<input
										className={styles.deviceInput}
										type="checkbox"
										checked={inMainSlider}
										onChange={(e) => setInMainSlider(e.target.checked)}
									/>
								</div>

								{/* ID подписки */}
								<h3 className={styles.titleH3}>ID подписки:</h3>
								<input
									type="text"
									placeholder="Введите ID подписки"
									value={subscriptionId}
									onChange={(e) => setSubscriptionId(e.target.value)}
								/>

								{/* Список устройств */}
								<h3 className={styles.titleH3}>Выбрать устройства:</h3>
								{loadingDevices ? (
									<p>Загрузка устройств...</p>
								) : (
									<div className={styles.devicesList}>
										{devices.map((device) => (
											<div key={device.id} className={styles.checkboxLabel}>
												<p>{device.name}</p>
												<input
													className={styles.deviceInput}
													type="checkbox"
													value={device.id}
													checked={selectedDevices.includes(device.id)}
													onChange={() => handleDeviceToggle(device.id)}
												/>
											</div>
										))}
									</div>
								)}
							</>
					}


					<div className={styles.buttons}>
						<button type="button" onClick={handleSubmit}>
							{item ? 'Сохранить' : 'Добавить'}
						</button>
						<button type="button" onClick={onClose}>
							Отмена
						</button>
					</div>
				</form>
			</div>
		</div>
	);
};
